<template lang="pug">
  b-modal.recepcionar-facturas-modal(
    ref="modal"
    title="Recepcionar Facturas SII"
    v-bind="$attrs"
    @show="onReset"
    @ok="onSubmit"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    ok-title="Iniciar Recepción")
    b-form
      p Se iniciará el proceso de web scraping para recepcionar los documentos pendientes de este cliente. Al finalizar, se enviará un reporte a los correos ingresados a continuación.
      
      b-form-group(label="Correos para Notificación")
        VueTagsInput(
          v-model="contactTagValue"
          placeholder="Añadir correo"
          :tags="contactTags"
          :validation="contactTagValidations"
          @tags-changed="newTags => { contactTags = newTags; contactTagValue = '' }"
        )
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.email.required") Debe proveer al menos un correo
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { emailValidator } from '../../shared/validations'
import VueTagsInput from '@johmun/vue-tags-input'
import api from '../../plugins/axios'

export default {
  inheritAttrs: false,
  components: {
    VueTagsInput
  },
  data () {
    return {
      contactTags: [],
      contactTagValue: '',
      contactTagValidations: [
        {
          classes: 'avoid-item',
          rule: ({ text }) => !emailValidator(text)
        }
      ],
      loading: false,
      defaultEmail: '',
      businessId: null,
      form: {
        email: ''
      }
    }
  },
  validations: {
    form: {
      email: { required }
    }
  },
  methods: {
    showModal (options) {
      this.defaultEmail = options.defaultEmail || ''
      this.businessId = options.businessId || null
      this.contactTags = options.defaultEmail ? options.defaultEmail.split(',').map(e => { return { text: e } }) : []
      this.$refs.modal.show()
    },
    onReset () {
      this.$v.$reset()
      this.form = {
        email: this.defaultEmail
      }
      this.contactTagValue = ''
      this.loading = false
    },
    async onSubmit (e) {
      if (this.$v.$invalid) {
        this.$v.$touch()
        e.preventDefault()
      } else {
        e.preventDefault() // Evitar cierre inmediato para esperar axios
        this.loading = true
        try {
          const emails = this.form.email.split(',')
          const response = await api.post(`/api/webscraping/approve-documents/${this.businessId}`, { emails })
          
          this.$root.$bvToast.toast(response.data.message || 'Proceso iniciado', {
            title: 'Éxito',
            variant: 'success'
          })
          this.$refs.modal.hide()
        } catch (error) {
          const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Error desconocido'
          this.$root.$bvToast.toast(message, {
            title: 'Oops!!',
            variant: 'danger'
          })
        } finally {
          this.loading = false
        }
      }
    }
  },
  watch: {
    contactTags () {
      this.form.email = this.contactTags.map(e => e.text.trim()).join(',')
    }
  }
}
</script>
